import {
  Component, ViewEncapsulation, ChangeDetectionStrategy, ChangeDetectorRef
} from '@angular/core';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '@environment';
import { DateTransformPipe } from '@app/pipes/date-format.pipe';
import { PlaceNamePipe } from '@app/pipes/place-name.pipe';
import { mapRecentHotelSearchData } from '@search-bar/mappers/url-search.mapper';
import { SearchParamFromType } from '@search-bar/entities/search-type';
import { hotelResultsRootRoute } from '@hotels/hotel-results/hotel-results-routing.module';
import { RecentSearchHotel } from '@recent-searches/entities/recent-search';
import { RecentSearchBaseComponent } from '@recent-searches/components/recent-search-base.component';

@Component({
  selector: 'app-hotel-recent-search',
  templateUrl: './hotel-recent-search.component.html',
  styleUrls: [],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class HotelRecentSearchComponent extends RecentSearchBaseComponent {

  constructor(
    protected router: Router,
    protected datePipe: DatePipe,
    protected dateTransformPipe: DateTransformPipe,
    protected placeNamePipe: PlaceNamePipe,
    protected changeDetector: ChangeDetectorRef
  ) {
    super(router, datePipe, dateTransformPipe, placeNamePipe, changeDetector);
  }

  get hotelSearch(): RecentSearchHotel {
    return this.search as RecentSearchHotel;
  }

  get isValidHotelRecentSearch(): boolean {
    if (this.hotelSearch.location_id) {
      return this.hotelSearch.isHotel ? !!this.hotelSearch.hotel_name : !!this.hotelSearch.destination;
    } else {
      return false;
    }
  }

  get getHotelRooms(): number {
    return !this.hotelSearch.rooms ? 0 : this.hotelSearch.rooms.length;
  }

  get getHotelTravelers(): number {
    return !this.hotelSearch.rooms || this.hotelSearch.rooms.length === 0 ? 0 :
      this.hotelSearch.rooms.reduce<number>(
        (prev, room) => prev + room.guests.reduce<number>(
          (sum, guest) => sum + guest.quantity, 0)
        , 0);
  }

  public getSimplePlaceName$(place: string): Observable<string> {
    return this.placeNamePipe.transform(place).pipe(map(placeInfo => placeInfo.split(',')[0]));
  }

  public searchHotels(): void {
    const _search = {
      ...this.hotelSearch,
      checkin: this.formatDateBySearch(this.hotelSearch?.checkin),
      checkout: this.formatDateBySearch(this.hotelSearch?.checkout)
    };
    const urlParams = mapRecentHotelSearchData(_search);
    this.router.navigate(
      [`${hotelResultsRootRoute}/${urlParams}`],
      {
        queryParams: {
          source: SearchParamFromType.RECENT,
          branch_code: _search?.branch_code ? _search.branch_code : environment.branchcode,
          from: SearchParamFromType.RECENT
        }
      }
    );
  }
}
